import type {Dayjs} from 'dayjs';

export enum SLAM_POINT_CLOUD_STATUS {
  DATA_PENDING = 'DATA_PENDING',
  DATA_UPLOADED = 'DATA_UPLOADED',
}

export type SlamPointCloud = {
  uuid: string;
  inventoryPlotUuid: string;
  status: SLAM_POINT_CLOUD_STATUS;
  date: Dayjs;
  lidarTechnologyUuid: string;
  comments?: string;
  createdAt: Dayjs;
};

export type SlamPointCloudCreate = Omit<SlamPointCloud, 'uuid'>;

export type SlamPointCloudUrls = {
  uploadUrl: string;
  downloadUrl: string;
};
